import styled from 'styled-components';
import {UnderlinedList} from '../../atoms/ListItem/index';
import {ThumbsUpIcon,StarIcon} from '../../atoms/Icons';
import {DefaultPrimaryColor, Grey500, Yellow, Green} from '../../Colors';

export default {
	ListItem : styled(UnderlinedList)`
		padding-top : 1rem;
	`,
	TitleWrapper : styled.div`
		display : flex;
		&>:last-child{
			margin-left : auto;
			color : ${Grey500};
		}
	`,
	Title : styled.div`
		font-size : 1.5rem;
		${({ checked }) => checked && `
			&:before{
				left: 0;
				bottom: 10px;
				content: '▶︎';
				margin-right : 0.5rem;
				color : ${DefaultPrimaryColor};
			}
		`}
	`,
	Description : styled.div`
		color : ${Grey500};
		margin-left : 1rem;
		font-size : 1rem;
	`,
	ListItemZero : styled(UnderlinedList)`
		margin-bottom : 1rem;
		border-bottom : none;
		position: relative;
		&:hover{
			border-bottom : none;
		}
		&:after{
			position: absolute;
			bottom: -2px;
			left: 0;
			content: '';
			width: 100%;
			height: 1px;
			background: ${DefaultPrimaryColor};
			transform: scale(0, 1);
			transform-origin: left top;
			transition: transform .3s;
		}
		${({ checked }) => checked && `
			&:after{
				transform: scale(1, 1);
			}
		`}
	`,
	StarIcon : styled(StarIcon)`
		color : ${Yellow};
		margin-right : 0.5rem;
	`,
	ThumbsUpIcon : styled(ThumbsUpIcon)`
		color : ${Green};
		margin-right : 0.5rem;
		margin-left : 1rem;
`,
};